import api from './api';
import type { SilentGuardPayload } from '../lib/silentGuard';

export type LeadResponse = {
  success: true;
  /** false when the silent guard flagged the submission — treat as success in the UI */
  accepted: boolean;
  leadId?: string;
};

export type RatingStartResponse = LeadResponse & {
  /** false when the workspace was created but the sign-in email could not be delivered */
  emailSent?: boolean;
  /** true when a never-used account got a fresh temporary app password */
  reissued?: boolean;
  loginUrl?: string;
};

type CaptchaProof = { captchaId: string; captchaAnswer: number };

/** Site content uses 'DEFAULT' when geo is unknown; the API only accepts ISO alpha-2. */
function isoCountry(code: string): string | undefined {
  return /^[A-Z]{2}$/.test(code) ? code : undefined;
}

export async function submitRatingStart(body: {
  name: string;
  email: string;
  phone: string;
  country: string;
  silent: SilentGuardPayload;
}) {
  const { data } = await api.post<RatingStartResponse>('/leads/start', { ...body, country: isoCountry(body.country) });
  return data;
}

export async function submitContact(
  body: { name: string; email: string; phone?: string; message: string; country: string; silent: SilentGuardPayload } & CaptchaProof,
) {
  const { data } = await api.post<LeadResponse>('/contact', { ...body, country: isoCountry(body.country) });
  return data;
}

export async function submitCountryRequest(
  body: { name: string; email: string; countryNeeded: string; reason: string; silent: SilentGuardPayload } & CaptchaProof,
) {
  const { data } = await api.post<LeadResponse>('/leads/country-request', body);
  return data;
}
